import { call, delay, put } from 'redux-saga/effects';
// api
import { apiPatient } from '../../api/patient';
import { getPatientActionReturnType } from '../../types/actions/patient';
// actions
import patientAction from '../actions/patient';
import resultsAction from '../actions/results';
import { TEST_HISTORY_PAGE_SIZE } from '../../constants/testHistoryPagination';

export function* sagaGetPatient(action: getPatientActionReturnType): any {
  try {
    yield delay(1);
    yield put(patientAction.patientLoading(true, 0));
    const patientResponse = yield call(apiPatient.getPatient, action.id);
    yield put(patientAction.patientLoading(true, 90));
    yield put(patientAction.patientLoading(true, 100));
    yield delay(500);
    yield put(resultsAction.resultsLoading(true, 0));
    yield put(resultsAction.getResultsClear());
    yield put(patientAction.getPatient(patientResponse.data.patientInfo[0]));
    yield put(patientAction.patientLoading(false, 0));
    yield put(
      resultsAction.getResultsAction(String(action.id), { first: TEST_HISTORY_PAGE_SIZE, skip: 0, letter: '' }),
    );
  } catch {
    // Request failed; loading state cleared in saga caller.
  }
}
